import { useEffect, useState } from 'react'
import { useAuth } from '../lib/AuthContext'
import { useLang } from '../lib/LangContext'
import { getEmployes, supprimerEmploye } from '../lib/api'
import GestionPIN from './GestionPIN'

export default function Employes() {
  const { boutiqueId, isPatron } = useAuth()
  const { lang } = useLang()
  const [employes, setEmployes] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState({ nom: '', role: 'caissier' })
  const [msg, setMsg] = useState(null)

  useEffect(() => { if (boutiqueId) load() }, [boutiqueId])

  async function load() {
    const { data } = await getEmployes(boutiqueId)
    setEmployes(data || [])
    setLoading(false)
  }

  async function handleSupprimer(emp) {
    if (!window.confirm(lang === 'fr' ? `Retirer ${emp.nom} ?` : `Remove ${emp.nom}?`)) return
    await supprimerEmploye(emp.id)
    load()
  }

  if (!isPatron) {
    return (
      <div className="main" style={{ textAlign: 'center', paddingTop: '3rem' }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🔒</div>
        <div style={{ fontFamily: 'Fraunces, serif', fontSize: 18, color: 'var(--charcoal)', marginBottom: 8 }}>
          {lang === 'fr' ? 'Accès réservé au patron' : 'Owner access only'}
        </div>
      </div>
    )
  }

  return (
    <div className="main">
      <div className="page-title">{lang === 'fr' ? '👥 Mon équipe' : '👥 My team'}</div>

      {/* ── SECTION PIN CAISSIER ── */}
      <div style={{ background: 'var(--warm-white)', border: '1px solid var(--cream-dark)', borderRadius: 'var(--radius-lg)', padding: '1.25rem', marginBottom: '1.25rem', boxShadow: 'var(--shadow-sm)' }}>
        <GestionPIN />
      </div>

      {/* ── COMMENT ÇA MARCHE ── */}
      <div style={{ background: 'var(--sage-pale)', border: '1px solid var(--sage-light)', borderRadius: 'var(--radius-md)', padding: '12px 14px', marginBottom: '1.25rem', fontSize: 12, color: 'var(--sage-dark)', lineHeight: 1.8 }}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          {lang === 'fr' ? 'Comment ça marche ?' : 'How does it work?'}
        </div>
        {lang === 'fr' ? (
          <>
            <div>1️⃣ Générez un PIN ci-dessus</div>
            <div>2️⃣ Envoyez-le à votre caissier par WhatsApp</div>
            <div>3️⃣ Le caissier ouvre StockO → clique <strong>"Accès caissier"</strong> → entre le PIN</div>
            <div>4️⃣ Il accède au stock sans créer de compte ✅</div>
          </>
        ) : (
          <>
            <div>1️⃣ Generate a PIN above</div>
            <div>2️⃣ Send it to your cashier via WhatsApp</div>
            <div>3️⃣ Cashier opens StockO → clicks <strong>"Cashier access"</strong> → enters PIN</div>
            <div>4️⃣ They access stock without creating an account ✅</div>
          </>
        )}
      </div>

      {/* ── LISTE EMPLOYÉS (optionnel, pour mémo) ── */}
      <div style={{ fontFamily: 'Fraunces, serif', fontSize: 16, color: 'var(--charcoal)', marginBottom: '0.75rem' }}>
        {lang === 'fr' ? 'Registre des caissiers' : 'Cashier registry'}
      </div>

      {loading ? (
        <div className="empty">Chargement...</div>
      ) : (
        <>
          {employes.filter(e => e.role !== 'patron').length === 0 ? (
            <div className="empty">
              <span className="empty-icon">👥</span>
              {lang === 'fr' ? 'Aucun caissier enregistré' : 'No cashiers registered'}
            </div>
          ) : (
            employes.filter(e => e.role !== 'patron').map(emp => (
              <div key={emp.id} className="product-item">
                <div className="product-icon" style={{ background: 'var(--sage-pale)', fontSize: 22 }}>🧑‍💼</div>
                <div className="product-info">
                  <div className="product-name">{emp.nom}</div>
                  <div className="product-meta" style={{ color: 'var(--sage)', fontWeight: 500 }}>Caissier</div>
                </div>
                <button onClick={() => handleSupprimer(emp)} style={{ padding: '6px 12px', borderRadius: 50, fontSize: 11, border: '1.5px solid #DFA0A0', background: 'var(--rose-pale)', color: 'var(--rose)', cursor: 'pointer', fontFamily: 'DM Sans, sans-serif', flexShrink: 0 }}>
                  {lang === 'fr' ? 'Retirer' : 'Remove'}
                </button>
              </div>
            ))
          )}

          <button className="btn-primary" style={{ marginTop: '1rem' }} onClick={() => setModal(true)}>
            {lang === 'fr' ? '+ Enregistrer un caissier' : '+ Register a cashier'}
          </button>
        </>
      )}

      {/* MODAL AJOUT (mémo uniquement) */}
      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal">
            <div className="modal-handle" />
            <div className="modal-title">{lang === 'fr' ? 'Enregistrer un caissier' : 'Register a cashier'}</div>
            <div style={{ fontSize: 12, color: 'var(--muted)', marginBottom: '1rem', lineHeight: 1.6 }}>
              {lang === 'fr'
                ? 'Gardez un registre de vos caissiers. Ils utilisent le PIN pour se connecter.'
                : 'Keep a record of your cashiers. They use the PIN to log in.'}
            </div>
            <div className="field">
              <label>{lang === 'fr' ? 'Nom du caissier' : 'Cashier name'}</label>
              <input type="text" placeholder={lang === 'fr' ? 'Ex: Jean Dupont' : 'Ex: John Doe'}
                value={form.nom} onChange={e => setForm(f => ({ ...f, nom: e.target.value }))} />
            </div>
            {msg && <div className={msg.type === 'success' ? 'success-msg' : 'error-msg'}>{msg.text}</div>}
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => { setModal(false); setMsg(null) }}>
                {lang === 'fr' ? 'Fermer' : 'Close'}
              </button>
              <button className="btn-confirm" onClick={async () => {
                if (!form.nom.trim()) { setMsg({ type: 'error', text: lang === 'fr' ? 'Nom requis.' : 'Name required.' }); return }
                const { supabase } = await import('../lib/supabase')
                await supabase.from('employes').insert({ boutique_id: boutiqueId, nom: form.nom.trim(), email: `${Date.now()}@pin.stocko`, role: 'caissier' })
                setMsg({ type: 'success', text: `✓ ${form.nom} ${lang === 'fr' ? 'enregistré !' : 'registered!'}` })
                setForm({ nom: '', role: 'caissier' })
                load()
                setTimeout(() => { setModal(false); setMsg(null) }, 1500)
              }}>
                {lang === 'fr' ? 'Enregistrer' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
